import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    balanceLabel: {
        id: '_.account_history.balanceLabel',
        defaultMessage: 'outstanding balance'
    },
    accountCTA: {
        id: '_.account_history.accountCTA',
        defaultMessage: 'See your transaction history'
    },
    credit_facility_label: {
        id: '_.account_history.credit_facility_account_label',
        defaultMessage: 'Flexi-Loan'
    },
    flexi24_label: {
        id: '_.account_history.flexi24_account_label',
        defaultMessage: 'Flexi-24 loan'
    },
    term_loan_label: {
        id: '_.account_history.term_loan_account_label',
        defaultMessage: 'Business loan'
    },
    iwocapay_label: {
        id: '_.account_history.iwocapay_account_label',
        defaultMessage: 'iwocaPay invoice'
    },
    cbils_label: {
        id: '_.account_history.cbils_account_label',
        defaultMessage: 'CBILS loan'
    }
});
